
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faq5x2QRpzMf_45WoM52gqi7SzFibNHSuBrAax3Y0G3v1zp0Meta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/faq.vue?macro=true";
import { default as docs_FPZTHz8YDmHEnGziwGv0rTG8AgtxWdWF4_45d9BZLEh8Meta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/docs.vue?macro=true";
import { default as about3OT7Vs2LYxosIvCJHC7EAY8gmSEig_b5hk7wqC3_3icMeta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/about.vue?macro=true";
import { default as indexhGe56Yd_45p_455a0LE1zKSttYRm0i7jM08321h4p5zUZtAMeta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/index.vue?macro=true";
import { default as loginCLk91CoQrgj_Qq54REFcLzl4stzAXiS1fOUnADJ5ViEMeta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/login.vue?macro=true";
import { default as terms6QgbTDoGELvwnaWUm9_kjWxzW3z7p_45pi746Ao4I9RjkMeta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/terms.vue?macro=true";
import { default as cookiesTx4HJlNZgmuAaZ8GX3M7s_45pOS4_Y7_45LDqN_454ISnqHtcMeta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/cookies.vue?macro=true";
import { default as contactsOzf0l_45Cq7vb9WIpLodFkG7GDRWw2JVcBvm7qEr5A7foMeta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/contacts.vue?macro=true";
import { default as registerbNMt0emjt7BbOP2aInitlUP_45VKOTwkkSsuXPfQAWRyoMeta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/register.vue?macro=true";
import { default as how_45it_45worksX9x9t2r6_45ku0ovxhvNp917Vuh_45cxjSNJCmUJhA0At5UMeta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/how-it-works.vue?macro=true";
import { default as verify_45emailTWNDGfY16q6fIFEoZ40sFKUrldwaz1_mYQqDjZ0pM3gMeta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/verify-email.vue?macro=true";
import { default as indexDkJUfb0MC2CKPTIMBlq3b_x7jvAC9mnc8ZLPGo5imTcMeta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/profile/index.vue?macro=true";
import { default as _91slug_93kDPonN5unKMmb4aegLS7dsjEZ7VR6mx_45IT5NAtWR3uEMeta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/[slug].vue?macro=true";
import { default as indexGy9EQAF8n0Dfk8S_45_4cZCVXxDGWrx_45xKGstCT6Vf7lwMeta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/workers/index.vue?macro=true";
import { default as privacy_45policyjJnuAYpYs_AoamRZU4RQrc_45xDP_JjzpjOcIGdgH1bu0Meta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/privacy-policy.vue?macro=true";
import { default as reset_45passwordpEWZjpix1GQTLdYtLLsYRsjsU99sTdV5lT02qgclshIMeta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/reset-password.vue?macro=true";
import { default as index4f0pV5yw3HGMfTrKHg4qUDeQdI8lDrR_u80qWJij_yoMeta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/settings/index.vue?macro=true";
import { default as _91slug_93iXApLmisB9Di90zpJCEmAU9VYmltccP_MhsV9gSos_UMeta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/workers/[slug].vue?macro=true";
import { default as forgot_45passwordO3nlOu01D7Ufke_Vx_454TqkmN9ilK_3kQZj2ip_45CiJxsMeta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/forgot-password.vue?macro=true";
import { default as for_45professionals0b8XQ1ZTgwtNKFwmzBmF1xbZWzegdMpbgHR_NJJyihwMeta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/for-professionals.vue?macro=true";
import { default as confirm_45email_45changez_bbcvi7BnzQIu2kn3mKZu_mnSUFOkEl40m0WeGeWiUMeta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/confirm-email-change.vue?macro=true";
import { default as indexB_jGwEv_45p9xnbJuyZWlkw_45VKcc40_h98DsYLOaZgW9gMeta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/index.vue?macro=true";
import { default as notifications8LgUm_45pNWkRM4_HysuTIqd_45uBLlI2A20L767FK8WnvMMeta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/settings/notifications.vue?macro=true";
import { default as regionsRT3SDzsBtx_yhLHMxu18g05n213vnz3lkRw6zG4hrBkMeta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/regions.vue?macro=true";
import { default as delete_45account_EmOYA9BxdGGXioKaFMs9ncsbJGvud2lenCJ1s8kKlYMeta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/settings/delete-account.vue?macro=true";
import { default as overviewTRlfG_vC_NXSc_45CyNibDXF47kTELyYnZY40d9EeLYoUMeta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/overview.vue?macro=true";
import { default as languagesqqDKep3OsYahASUqKES7U4Q6mp6Hn9U0e4bV6R3YxQ4Meta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/languages.vue?macro=true";
import { default as _91second_93bGHjskacbkotUbpxoYwmmKBr8Kvu6zod0LHYrX4s6CAMeta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/workers/[first]/[second].vue?macro=true";
import { default as deactivateA_456mPAaiZFMM5gfdrEy_ulMzqT_45SMkjCsaK5YRJ2rgQMeta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/deactivate.vue?macro=true";
import { default as _91id_939qkGbKslN8XNkZaKuTkhZQHNdEL0uabdu4cfY_NDoZMMeta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/services/[id].vue?macro=true";
import { default as _91id_93Yq8H6GgSBbLmdwJUoOugo9_45BFg4tKnzFkOOg5T2PtKcMeta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/education/[id].vue?macro=true";
import { default as index7ySWkioFI3H_45qxAaU_4591964e3uzpzpFq1Abr55XFJcQMeta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/services/index.vue?macro=true";
import { default as indexK4ZLcQ0KHvI5dxIUZ7mFCXpHYKrSw6Dq4R8zFOxWMVkMeta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/education/index.vue?macro=true";
import { default as _91id_93jV2_45Sd24WVCWG8cpMif2rxUBGDmTMeJQfY_45lme61Ih4Meta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/experience/[id].vue?macro=true";
import { default as indexLz3iawuPa3C6JKdQcONH5JgM6_las9dBGXqO_a4KZHcMeta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/experience/index.vue?macro=true";
import { default as _91region_936tlBFAYMxgTwB7ECCjXepdwJIJhSko3ZQ3xNtMhddVIMeta } from "/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/workers/[category]/[service]/[region].vue?macro=true";
export default [
  {
    name: "faq___lt",
    path: "/faq",
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/faq.vue")
  },
  {
    name: "faq___en",
    path: "/en/faq",
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/faq.vue")
  },
  {
    name: "faq___ru",
    path: "/ru/faq",
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/faq.vue")
  },
  {
    name: "docs___lt",
    path: "/docs",
    meta: { ...(docs_FPZTHz8YDmHEnGziwGv0rTG8AgtxWdWF4_45d9BZLEh8Meta || {}), ...{"middleware":["dev-only"]} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/docs.vue")
  },
  {
    name: "docs___en",
    path: "/en/docs",
    meta: { ...(docs_FPZTHz8YDmHEnGziwGv0rTG8AgtxWdWF4_45d9BZLEh8Meta || {}), ...{"middleware":["dev-only"]} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/docs.vue")
  },
  {
    name: "docs___ru",
    path: "/ru/docs",
    meta: { ...(docs_FPZTHz8YDmHEnGziwGv0rTG8AgtxWdWF4_45d9BZLEh8Meta || {}), ...{"middleware":["dev-only"]} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/docs.vue")
  },
  {
    name: "about___lt",
    path: "/about",
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/about.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/about.vue")
  },
  {
    name: "about___ru",
    path: "/ru/about",
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/about.vue")
  },
  {
    name: "index___lt",
    path: "/",
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/index.vue")
  },
  {
    name: "login___lt",
    path: "/login",
    meta: loginCLk91CoQrgj_Qq54REFcLzl4stzAXiS1fOUnADJ5ViEMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    meta: loginCLk91CoQrgj_Qq54REFcLzl4stzAXiS1fOUnADJ5ViEMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/login.vue")
  },
  {
    name: "login___ru",
    path: "/ru/login",
    meta: loginCLk91CoQrgj_Qq54REFcLzl4stzAXiS1fOUnADJ5ViEMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/login.vue")
  },
  {
    name: "terms___lt",
    path: "/terms",
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/terms.vue")
  },
  {
    name: "terms___en",
    path: "/en/terms",
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/terms.vue")
  },
  {
    name: "terms___ru",
    path: "/ru/terms",
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/terms.vue")
  },
  {
    name: "cookies___lt",
    path: "/cookies",
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/cookies.vue")
  },
  {
    name: "cookies___en",
    path: "/en/cookies",
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/cookies.vue")
  },
  {
    name: "cookies___ru",
    path: "/ru/cookies",
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/cookies.vue")
  },
  {
    name: "contacts___lt",
    path: "/contacts",
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/contacts.vue")
  },
  {
    name: "contacts___en",
    path: "/en/contacts",
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/contacts.vue")
  },
  {
    name: "contacts___ru",
    path: "/ru/contacts",
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/contacts.vue")
  },
  {
    name: "register___lt",
    path: "/register",
    meta: registerbNMt0emjt7BbOP2aInitlUP_45VKOTwkkSsuXPfQAWRyoMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/register.vue")
  },
  {
    name: "register___en",
    path: "/en/register",
    meta: registerbNMt0emjt7BbOP2aInitlUP_45VKOTwkkSsuXPfQAWRyoMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/register.vue")
  },
  {
    name: "register___ru",
    path: "/ru/register",
    meta: registerbNMt0emjt7BbOP2aInitlUP_45VKOTwkkSsuXPfQAWRyoMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/register.vue")
  },
  {
    name: "how-it-works___lt",
    path: "/how-it-works",
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/how-it-works.vue")
  },
  {
    name: "how-it-works___en",
    path: "/en/how-it-works",
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/how-it-works.vue")
  },
  {
    name: "how-it-works___ru",
    path: "/ru/how-it-works",
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/how-it-works.vue")
  },
  {
    name: "verify-email___lt",
    path: "/verify-email",
    meta: verify_45emailTWNDGfY16q6fIFEoZ40sFKUrldwaz1_mYQqDjZ0pM3gMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/verify-email.vue")
  },
  {
    name: "verify-email___en",
    path: "/en/verify-email",
    meta: verify_45emailTWNDGfY16q6fIFEoZ40sFKUrldwaz1_mYQqDjZ0pM3gMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/verify-email.vue")
  },
  {
    name: "verify-email___ru",
    path: "/ru/verify-email",
    meta: verify_45emailTWNDGfY16q6fIFEoZ40sFKUrldwaz1_mYQqDjZ0pM3gMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/verify-email.vue")
  },
  {
    name: "profile___lt",
    path: "/profile",
    meta: indexDkJUfb0MC2CKPTIMBlq3b_x7jvAC9mnc8ZLPGo5imTcMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/profile/index.vue")
  },
  {
    name: "profile___en",
    path: "/en/profile",
    meta: indexDkJUfb0MC2CKPTIMBlq3b_x7jvAC9mnc8ZLPGo5imTcMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/profile/index.vue")
  },
  {
    name: "profile___ru",
    path: "/ru/profile",
    meta: indexDkJUfb0MC2CKPTIMBlq3b_x7jvAC9mnc8ZLPGo5imTcMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/profile/index.vue")
  },
  {
    name: "worker-slug___lt",
    path: "/worker/:slug()",
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/[slug].vue")
  },
  {
    name: "worker-slug___en",
    path: "/en/worker/:slug()",
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/[slug].vue")
  },
  {
    name: "worker-slug___ru",
    path: "/ru/worker/:slug()",
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/[slug].vue")
  },
  {
    name: "workers___lt",
    path: "/workers",
    meta: indexGy9EQAF8n0Dfk8S_45_4cZCVXxDGWrx_45xKGstCT6Vf7lwMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/workers/index.vue")
  },
  {
    name: "workers___en",
    path: "/en/workers",
    meta: indexGy9EQAF8n0Dfk8S_45_4cZCVXxDGWrx_45xKGstCT6Vf7lwMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/workers/index.vue")
  },
  {
    name: "workers___ru",
    path: "/ru/workers",
    meta: indexGy9EQAF8n0Dfk8S_45_4cZCVXxDGWrx_45xKGstCT6Vf7lwMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/workers/index.vue")
  },
  {
    name: "privacy-policy___lt",
    path: "/privacy-policy",
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___en",
    path: "/en/privacy-policy",
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___ru",
    path: "/ru/privacy-policy",
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/privacy-policy.vue")
  },
  {
    name: "reset-password___lt",
    path: "/reset-password",
    meta: reset_45passwordpEWZjpix1GQTLdYtLLsYRsjsU99sTdV5lT02qgclshIMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/reset-password.vue")
  },
  {
    name: "reset-password___en",
    path: "/en/reset-password",
    meta: reset_45passwordpEWZjpix1GQTLdYtLLsYRsjsU99sTdV5lT02qgclshIMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/reset-password.vue")
  },
  {
    name: "reset-password___ru",
    path: "/ru/reset-password",
    meta: reset_45passwordpEWZjpix1GQTLdYtLLsYRsjsU99sTdV5lT02qgclshIMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/reset-password.vue")
  },
  {
    name: "settings___lt",
    path: "/settings",
    meta: index4f0pV5yw3HGMfTrKHg4qUDeQdI8lDrR_u80qWJij_yoMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/settings/index.vue")
  },
  {
    name: "settings___en",
    path: "/en/settings",
    meta: index4f0pV5yw3HGMfTrKHg4qUDeQdI8lDrR_u80qWJij_yoMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/settings/index.vue")
  },
  {
    name: "settings___ru",
    path: "/ru/settings",
    meta: index4f0pV5yw3HGMfTrKHg4qUDeQdI8lDrR_u80qWJij_yoMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/settings/index.vue")
  },
  {
    name: "workers-slug___lt",
    path: "/workers/:slug()",
    meta: _91slug_93iXApLmisB9Di90zpJCEmAU9VYmltccP_MhsV9gSos_UMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/workers/[slug].vue")
  },
  {
    name: "workers-slug___en",
    path: "/en/workers/:slug()",
    meta: _91slug_93iXApLmisB9Di90zpJCEmAU9VYmltccP_MhsV9gSos_UMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/workers/[slug].vue")
  },
  {
    name: "workers-slug___ru",
    path: "/ru/workers/:slug()",
    meta: _91slug_93iXApLmisB9Di90zpJCEmAU9VYmltccP_MhsV9gSos_UMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/workers/[slug].vue")
  },
  {
    name: "forgot-password___lt",
    path: "/forgot-password",
    meta: forgot_45passwordO3nlOu01D7Ufke_Vx_454TqkmN9ilK_3kQZj2ip_45CiJxsMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___en",
    path: "/en/forgot-password",
    meta: forgot_45passwordO3nlOu01D7Ufke_Vx_454TqkmN9ilK_3kQZj2ip_45CiJxsMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___ru",
    path: "/ru/forgot-password",
    meta: forgot_45passwordO3nlOu01D7Ufke_Vx_454TqkmN9ilK_3kQZj2ip_45CiJxsMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/forgot-password.vue")
  },
  {
    name: "for-professionals___lt",
    path: "/for-professionals",
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/for-professionals.vue")
  },
  {
    name: "for-professionals___en",
    path: "/en/for-professionals",
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/for-professionals.vue")
  },
  {
    name: "for-professionals___ru",
    path: "/ru/for-professionals",
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/for-professionals.vue")
  },
  {
    name: "confirm-email-change___lt",
    path: "/confirm-email-change",
    meta: confirm_45email_45changez_bbcvi7BnzQIu2kn3mKZu_mnSUFOkEl40m0WeGeWiUMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/confirm-email-change.vue")
  },
  {
    name: "confirm-email-change___en",
    path: "/en/confirm-email-change",
    meta: confirm_45email_45changez_bbcvi7BnzQIu2kn3mKZu_mnSUFOkEl40m0WeGeWiUMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/confirm-email-change.vue")
  },
  {
    name: "confirm-email-change___ru",
    path: "/ru/confirm-email-change",
    meta: confirm_45email_45changez_bbcvi7BnzQIu2kn3mKZu_mnSUFOkEl40m0WeGeWiUMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/confirm-email-change.vue")
  },
  {
    name: "worker-profile___lt",
    path: "/worker/profile",
    meta: { ...(indexB_jGwEv_45p9xnbJuyZWlkw_45VKcc40_h98DsYLOaZgW9gMeta || {}), ...{"middleware":"worker"} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/index.vue")
  },
  {
    name: "worker-profile___en",
    path: "/en/worker/profile",
    meta: { ...(indexB_jGwEv_45p9xnbJuyZWlkw_45VKcc40_h98DsYLOaZgW9gMeta || {}), ...{"middleware":"worker"} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/index.vue")
  },
  {
    name: "worker-profile___ru",
    path: "/ru/worker/profile",
    meta: { ...(indexB_jGwEv_45p9xnbJuyZWlkw_45VKcc40_h98DsYLOaZgW9gMeta || {}), ...{"middleware":"worker"} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/index.vue")
  },
  {
    name: "settings-notifications___lt",
    path: "/settings/notifications",
    meta: notifications8LgUm_45pNWkRM4_HysuTIqd_45uBLlI2A20L767FK8WnvMMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/settings/notifications.vue")
  },
  {
    name: "settings-notifications___en",
    path: "/en/settings/notifications",
    meta: notifications8LgUm_45pNWkRM4_HysuTIqd_45uBLlI2A20L767FK8WnvMMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/settings/notifications.vue")
  },
  {
    name: "settings-notifications___ru",
    path: "/ru/settings/notifications",
    meta: notifications8LgUm_45pNWkRM4_HysuTIqd_45uBLlI2A20L767FK8WnvMMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/settings/notifications.vue")
  },
  {
    name: "worker-profile-regions___lt",
    path: "/worker/profile/regions",
    meta: { ...(regionsRT3SDzsBtx_yhLHMxu18g05n213vnz3lkRw6zG4hrBkMeta || {}), ...{"middleware":"worker"} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/regions.vue")
  },
  {
    name: "worker-profile-regions___en",
    path: "/en/worker/profile/regions",
    meta: { ...(regionsRT3SDzsBtx_yhLHMxu18g05n213vnz3lkRw6zG4hrBkMeta || {}), ...{"middleware":"worker"} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/regions.vue")
  },
  {
    name: "worker-profile-regions___ru",
    path: "/ru/worker/profile/regions",
    meta: { ...(regionsRT3SDzsBtx_yhLHMxu18g05n213vnz3lkRw6zG4hrBkMeta || {}), ...{"middleware":"worker"} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/regions.vue")
  },
  {
    name: "settings-delete-account___lt",
    path: "/settings/delete-account",
    meta: delete_45account_EmOYA9BxdGGXioKaFMs9ncsbJGvud2lenCJ1s8kKlYMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/settings/delete-account.vue")
  },
  {
    name: "settings-delete-account___en",
    path: "/en/settings/delete-account",
    meta: delete_45account_EmOYA9BxdGGXioKaFMs9ncsbJGvud2lenCJ1s8kKlYMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/settings/delete-account.vue")
  },
  {
    name: "settings-delete-account___ru",
    path: "/ru/settings/delete-account",
    meta: delete_45account_EmOYA9BxdGGXioKaFMs9ncsbJGvud2lenCJ1s8kKlYMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/settings/delete-account.vue")
  },
  {
    name: "worker-profile-overview___lt",
    path: "/worker/profile/overview",
    meta: { ...(overviewTRlfG_vC_NXSc_45CyNibDXF47kTELyYnZY40d9EeLYoUMeta || {}), ...{"middleware":"worker"} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/overview.vue")
  },
  {
    name: "worker-profile-overview___en",
    path: "/en/worker/profile/overview",
    meta: { ...(overviewTRlfG_vC_NXSc_45CyNibDXF47kTELyYnZY40d9EeLYoUMeta || {}), ...{"middleware":"worker"} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/overview.vue")
  },
  {
    name: "worker-profile-overview___ru",
    path: "/ru/worker/profile/overview",
    meta: { ...(overviewTRlfG_vC_NXSc_45CyNibDXF47kTELyYnZY40d9EeLYoUMeta || {}), ...{"middleware":"worker"} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/overview.vue")
  },
  {
    name: "worker-profile-languages___lt",
    path: "/worker/profile/languages",
    meta: { ...(languagesqqDKep3OsYahASUqKES7U4Q6mp6Hn9U0e4bV6R3YxQ4Meta || {}), ...{"middleware":"worker"} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/languages.vue")
  },
  {
    name: "worker-profile-languages___en",
    path: "/en/worker/profile/languages",
    meta: { ...(languagesqqDKep3OsYahASUqKES7U4Q6mp6Hn9U0e4bV6R3YxQ4Meta || {}), ...{"middleware":"worker"} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/languages.vue")
  },
  {
    name: "worker-profile-languages___ru",
    path: "/ru/worker/profile/languages",
    meta: { ...(languagesqqDKep3OsYahASUqKES7U4Q6mp6Hn9U0e4bV6R3YxQ4Meta || {}), ...{"middleware":"worker"} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/languages.vue")
  },
  {
    name: "workers-first-second___lt",
    path: "/workers/:first()/:second()",
    meta: _91second_93bGHjskacbkotUbpxoYwmmKBr8Kvu6zod0LHYrX4s6CAMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/workers/[first]/[second].vue")
  },
  {
    name: "workers-first-second___en",
    path: "/en/workers/:first()/:second()",
    meta: _91second_93bGHjskacbkotUbpxoYwmmKBr8Kvu6zod0LHYrX4s6CAMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/workers/[first]/[second].vue")
  },
  {
    name: "workers-first-second___ru",
    path: "/ru/workers/:first()/:second()",
    meta: _91second_93bGHjskacbkotUbpxoYwmmKBr8Kvu6zod0LHYrX4s6CAMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/workers/[first]/[second].vue")
  },
  {
    name: "worker-profile-deactivate___lt",
    path: "/worker/profile/deactivate",
    meta: { ...(deactivateA_456mPAaiZFMM5gfdrEy_ulMzqT_45SMkjCsaK5YRJ2rgQMeta || {}), ...{"middleware":"worker"} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/deactivate.vue")
  },
  {
    name: "worker-profile-deactivate___en",
    path: "/en/worker/profile/deactivate",
    meta: { ...(deactivateA_456mPAaiZFMM5gfdrEy_ulMzqT_45SMkjCsaK5YRJ2rgQMeta || {}), ...{"middleware":"worker"} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/deactivate.vue")
  },
  {
    name: "worker-profile-deactivate___ru",
    path: "/ru/worker/profile/deactivate",
    meta: { ...(deactivateA_456mPAaiZFMM5gfdrEy_ulMzqT_45SMkjCsaK5YRJ2rgQMeta || {}), ...{"middleware":"worker"} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/deactivate.vue")
  },
  {
    name: "worker-profile-services-id___lt",
    path: "/worker/profile/services/:id()",
    meta: { ...(_91id_939qkGbKslN8XNkZaKuTkhZQHNdEL0uabdu4cfY_NDoZMMeta || {}), ...{"middleware":"worker"} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/services/[id].vue")
  },
  {
    name: "worker-profile-services-id___en",
    path: "/en/worker/profile/services/:id()",
    meta: { ...(_91id_939qkGbKslN8XNkZaKuTkhZQHNdEL0uabdu4cfY_NDoZMMeta || {}), ...{"middleware":"worker"} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/services/[id].vue")
  },
  {
    name: "worker-profile-services-id___ru",
    path: "/ru/worker/profile/services/:id()",
    meta: { ...(_91id_939qkGbKslN8XNkZaKuTkhZQHNdEL0uabdu4cfY_NDoZMMeta || {}), ...{"middleware":"worker"} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/services/[id].vue")
  },
  {
    name: "worker-profile-education-id___lt",
    path: "/worker/profile/education/:id()",
    meta: { ...(_91id_93Yq8H6GgSBbLmdwJUoOugo9_45BFg4tKnzFkOOg5T2PtKcMeta || {}), ...{"middleware":"worker"} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/education/[id].vue")
  },
  {
    name: "worker-profile-education-id___en",
    path: "/en/worker/profile/education/:id()",
    meta: { ...(_91id_93Yq8H6GgSBbLmdwJUoOugo9_45BFg4tKnzFkOOg5T2PtKcMeta || {}), ...{"middleware":"worker"} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/education/[id].vue")
  },
  {
    name: "worker-profile-education-id___ru",
    path: "/ru/worker/profile/education/:id()",
    meta: { ...(_91id_93Yq8H6GgSBbLmdwJUoOugo9_45BFg4tKnzFkOOg5T2PtKcMeta || {}), ...{"middleware":"worker"} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/education/[id].vue")
  },
  {
    name: "worker-profile-services___lt",
    path: "/worker/profile/services",
    meta: { ...(index7ySWkioFI3H_45qxAaU_4591964e3uzpzpFq1Abr55XFJcQMeta || {}), ...{"middleware":"worker"} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/services/index.vue")
  },
  {
    name: "worker-profile-services___en",
    path: "/en/worker/profile/services",
    meta: { ...(index7ySWkioFI3H_45qxAaU_4591964e3uzpzpFq1Abr55XFJcQMeta || {}), ...{"middleware":"worker"} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/services/index.vue")
  },
  {
    name: "worker-profile-services___ru",
    path: "/ru/worker/profile/services",
    meta: { ...(index7ySWkioFI3H_45qxAaU_4591964e3uzpzpFq1Abr55XFJcQMeta || {}), ...{"middleware":"worker"} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/services/index.vue")
  },
  {
    name: "worker-profile-education___lt",
    path: "/worker/profile/education",
    meta: { ...(indexK4ZLcQ0KHvI5dxIUZ7mFCXpHYKrSw6Dq4R8zFOxWMVkMeta || {}), ...{"middleware":"worker"} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/education/index.vue")
  },
  {
    name: "worker-profile-education___en",
    path: "/en/worker/profile/education",
    meta: { ...(indexK4ZLcQ0KHvI5dxIUZ7mFCXpHYKrSw6Dq4R8zFOxWMVkMeta || {}), ...{"middleware":"worker"} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/education/index.vue")
  },
  {
    name: "worker-profile-education___ru",
    path: "/ru/worker/profile/education",
    meta: { ...(indexK4ZLcQ0KHvI5dxIUZ7mFCXpHYKrSw6Dq4R8zFOxWMVkMeta || {}), ...{"middleware":"worker"} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/education/index.vue")
  },
  {
    name: "worker-profile-experience-id___lt",
    path: "/worker/profile/experience/:id()",
    meta: { ...(_91id_93jV2_45Sd24WVCWG8cpMif2rxUBGDmTMeJQfY_45lme61Ih4Meta || {}), ...{"middleware":"worker"} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/experience/[id].vue")
  },
  {
    name: "worker-profile-experience-id___en",
    path: "/en/worker/profile/experience/:id()",
    meta: { ...(_91id_93jV2_45Sd24WVCWG8cpMif2rxUBGDmTMeJQfY_45lme61Ih4Meta || {}), ...{"middleware":"worker"} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/experience/[id].vue")
  },
  {
    name: "worker-profile-experience-id___ru",
    path: "/ru/worker/profile/experience/:id()",
    meta: { ...(_91id_93jV2_45Sd24WVCWG8cpMif2rxUBGDmTMeJQfY_45lme61Ih4Meta || {}), ...{"middleware":"worker"} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/experience/[id].vue")
  },
  {
    name: "worker-profile-experience___lt",
    path: "/worker/profile/experience",
    meta: { ...(indexLz3iawuPa3C6JKdQcONH5JgM6_las9dBGXqO_a4KZHcMeta || {}), ...{"middleware":"worker"} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/experience/index.vue")
  },
  {
    name: "worker-profile-experience___en",
    path: "/en/worker/profile/experience",
    meta: { ...(indexLz3iawuPa3C6JKdQcONH5JgM6_las9dBGXqO_a4KZHcMeta || {}), ...{"middleware":"worker"} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/experience/index.vue")
  },
  {
    name: "worker-profile-experience___ru",
    path: "/ru/worker/profile/experience",
    meta: { ...(indexLz3iawuPa3C6JKdQcONH5JgM6_las9dBGXqO_a4KZHcMeta || {}), ...{"middleware":"worker"} },
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/worker/profile/experience/index.vue")
  },
  {
    name: "workers-category-service-region___lt",
    path: "/workers/:category()/:service()/:region()",
    meta: _91region_936tlBFAYMxgTwB7ECCjXepdwJIJhSko3ZQ3xNtMhddVIMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/workers/[category]/[service]/[region].vue")
  },
  {
    name: "workers-category-service-region___en",
    path: "/en/workers/:category()/:service()/:region()",
    meta: _91region_936tlBFAYMxgTwB7ECCjXepdwJIJhSko3ZQ3xNtMhddVIMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/workers/[category]/[service]/[region].vue")
  },
  {
    name: "workers-category-service-region___ru",
    path: "/ru/workers/:category()/:service()/:region()",
    meta: _91region_936tlBFAYMxgTwB7ECCjXepdwJIJhSko3ZQ3xNtMhddVIMeta || {},
    component: () => import("/var/www/senta/releases/4fc37d2e1b7bc299c88c5a9b335f9c6cd9883024/pages/workers/[category]/[service]/[region].vue")
  }
]